import React, { memo } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import BaseSection from '../BaseSection';

const AdditionalInfoSection = memo(({ specialOffers }) => (
  <BaseSection>
    <div className="additional-info__container">
      {specialOffers?.map((el, index) => (
        <div
          className={cn('additional-info__i', el.offerType.toLowerCase())}
          key={index}
        >
          <div className="additional-info__i-text">
            <div className="additional-info__i-title">{el.name}</div>
            {el.description}
          </div>
        </div>
      ))}
    </div>
  </BaseSection>
));

AdditionalInfoSection.displayName = `AdditionalInfoSection`;

AdditionalInfoSection.propTypes = {
  specialOffers: PropTypes.array
};

export default AdditionalInfoSection;
